module.exports = __webpack_public_path__ + "img/f50.c98fdc74.png";